module.exports = __webpack_public_path__ + "media/images/pic/bialoleka/hero-exam-baa09925499da52b1a27cdbd3e37c965.png";